import { useEffect, useState } from "react";
import { landingContent } from "../../data/landingContent";
import { getAvatarUrl } from "../../utils/avatars";

function Step1Illustration() {
  const [text, setText] = useState("");
  const nameToType = "jake.miller";

  useEffect(() => {
    let index = 0;
    let isDeleting = false;
    let timer: any;

    const type = () => {
      const current = nameToType.substring(0, index);
      setText(current);

      if (!isDeleting) {
        if (index < nameToType.length) {
          index++;
          timer = setTimeout(type, 140);
        } else {
          // Pause at the end
          timer = setTimeout(() => {
            isDeleting = true;
            type();
          }, 2000);
        }
      } else {
        if (index > 0) {
          index--;
          timer = setTimeout(type, 80);
        } else {
          isDeleting = false;
          // Pause before starting again
          timer = setTimeout(type, 500);
        }
      }
    };

    type();
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="st-step-illustration">
      <div className="st-step1-mockup">
        {/* Profile avatar with Instagram gradient ring */}
        <div
          className="st-step1-avatar-ring"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div className="st-step1-avatar-inner" style={{ overflow: "hidden" }}>
            <img
              src={getAvatarUrl("male", 4)}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </div>
        </div>
        {/* Animated search bar */}
        <div className="st-step1-search">
          <span className="st-step1-at">@</span>
          <span
            style={{
              fontSize: "0.8125rem",
              fontWeight: 700,
              color: "var(--slate-800)",
              height: "16px",
              display: "inline-flex",
              alignItems: "center",
            }}
          >
            {text}
          </span>
          <span className="st-step1-cursor" aria-hidden="true" />
        </div>
      </div>
    </div>
  );
}

function Step2Illustration() {
  const { howItWorks } = landingContent;
  const s2 = howItWorks.step2 || {
    scanning: "Scanning...",
    newBadge: "NEW",
    timeAgo: "2h ago",
  };

  return (
    <div className="st-step-illustration">
      <div
        className="st-step2-mockup"
        style={{
          width: "100%",
          maxWidth: "220px",
          background: "#FFF",
          borderRadius: "12px",
          padding: "12px",
          boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
          border: "1px solid rgba(15, 23, 42, 0.06)",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
        }}
      >
        {/* Profile Card Header */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            borderBottom: "1px solid rgba(15,23,42,0.06)",
            paddingBottom: "8px",
          }}
        >
          <div
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              overflow: "hidden",
              border: "1px solid rgba(15,23,42,0.08)",
            }}
          >
            <img
              src={getAvatarUrl("male", 4)}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                display: "block",
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              textAlign: "left",
            }}
          >
            <span
              style={{
                fontSize: "0.6875rem",
                fontWeight: 800,
                color: "var(--slate-800)",
                lineHeight: 1,
              }}
            >
              @jake.miller
            </span>
            <span
              style={{
                fontSize: "0.5625rem",
                color: "var(--slate-400)",
                fontWeight: 500,
                marginTop: "2px",
              }}
            >
              {s2.scanning}
            </span>
          </div>
          {/* Pulsing Scan Radar */}
          <div
            style={{
              marginLeft: "auto",
              position: "relative",
              width: "8px",
              height: "8px",
            }}
          >
            <span
              className="st-pulse-dot"
              style={{
                display: "block",
                width: "100%",
                height: "100%",
                borderRadius: "50%",
                background: "var(--pink-primary)",
              }}
            />
            <span
              className="st-pulse-ring"
              style={{
                position: "absolute",
                inset: 0,
                borderRadius: "50%",
                border: "1px solid var(--pink-primary)",
                animation: "ping 1.5s cubic-bezier(0, 0, 0.2, 1) infinite",
              }}
            />
          </div>
        </div>

        {/* List of Follows */}
        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              background: "rgba(255, 107, 138, 0.04)",
              border: "1px solid rgba(255, 107, 138, 0.08)",
              borderRadius: "8px",
              padding: "6px 8px",
            }}
          >
            <div
              style={{
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                overflow: "hidden",
              }}
            >
              <img
                src={getAvatarUrl("female", 0)}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </div>
            <span
              style={{
                fontSize: "0.6875rem",
                fontWeight: 700,
                color: "var(--slate-800)",
              }}
            >
              @emma.parker
            </span>
            <span
              style={{
                marginLeft: "auto",
                fontSize: "0.5625rem",
                fontWeight: 800,
                color: "var(--pink-primary)",
                background: "rgba(255, 107, 138, 0.1)",
                padding: "2px 4px",
                borderRadius: "4px",
              }}
            >
              {s2.newBadge}
            </span>
          </div>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              background: "#FFF",
              border: "1px solid rgba(15, 23, 42, 0.05)",
              borderRadius: "8px",
              padding: "6px 8px",
            }}
          >
            <div
              style={{
                width: "18px",
                height: "18px",
                borderRadius: "50%",
                overflow: "hidden",
              }}
            >
              <img
                src={getAvatarUrl("female", 3)}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />
            </div>
            <span
              style={{
                fontSize: "0.6875rem",
                fontWeight: 700,
                color: "var(--slate-800)",
              }}
            >
              @sophia.brooks
            </span>
            <span
              style={{
                marginLeft: "auto",
                fontSize: "0.5625rem",
                color: "var(--slate-400)",
                fontWeight: 500,
              }}
            >
              {s2.timeAgo}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}

function Step3Illustration() {
  const { howItWorks } = landingContent;
  const events = howItWorks.step3Events || [];
  // Duplicate for seamless loop
  const allEvents = [...events, ...events];

  return (
    <div className="st-step-illustration" style={{ padding: 0 }}>
      <div className="st-step3-feed-wrap">
        <div className="st-step3-feed-track">
          {allEvents.map((ev, i) => (
            <div key={i} className={`st-step3-event type-${ev.type}`}>
              <div
                className="st-step3-event-avatar"
                style={{ background: ev.avatarBg + "22", color: ev.avatarBg }}
              >
                {ev.avatar}
              </div>
              <div className="st-step3-event-body">
                <div className="st-step3-event-time">{ev.time}</div>
                <div className="st-step3-event-text">{ev.text}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export function HowItWorks() {
  const { howItWorks } = landingContent;

  const illustrations = [
    <Step1Illustration key="s1" />,
    <Step2Illustration key="s2" />,
    <Step3Illustration key="s3" />,
  ];

  return (
    <section
      className="st-section"
      style={{ background: "var(--gray-light)" }}
      aria-label="How it works"
    >
      <div className="st-container">
        <div
          style={{ textAlign: "center", marginBottom: "40px" }}
          className="st-reveal"
        >
          <div className="st-eyebrow">{howItWorks.eyebrow}</div>
          <h2 className="st-heading-2">{howItWorks.title}</h2>
          <p
            className="st-body-large"
            style={{ maxWidth: "520px", margin: "10px auto 0" }}
          >
            {howItWorks.subtitle}
          </p>
        </div>

        <div className="st-steps st-reveal">
          {howItWorks.steps.map((step, i) => (
            <article key={i} className="st-step-card">
              {illustrations[i]}
              <div className="st-step-badge">{step.badge}</div>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
